// extracted by mini-css-extract-plugin
export default {"header":"Header_header__MY7fH","content":"Header_content__iRQsp","leftCell":"Header_leftCell__1fxHo","user":"Header_user__vuEVt"};